import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Topics from "@/pages/topics/page";
import TopicDetail from "@/pages/topic-detail/page";
import Memes from "@/pages/memes/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/topics",
        element: <Topics />,
      },
      {
        path: "/topics/:id",
        element: <TopicDetail />,
      },
      {
        path: "/memes",
        element: <Memes />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/faq",
        element: <Faq />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;